const compose = (...funcs: Function[]): Function =>
  funcs.reduce(
    (accumulator: Function, func: Function) => (...args: any[]): Function =>
      accumulator(func(...args)),
    (arg: any) => arg
  );

export default compose;
